'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListCompanyController = function () {
  function ListCompanyController(entityService, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ListCompanyController);
    this._entityService = entityService;
    this.loadingService = loadingService;

    this.companies = [];

    this.listCompanies();
  }

  (0, _createClass3.default)(ListCompanyController, [{
    key: 'listCompanies',
    value: function listCompanies(entityType) {
      var listCompanyCtrl = this;

      listCompanyCtrl.loadingService.showLoading('companyList', 'Loading Entities ...');

      this._entityService.listEntities(1).then(function (response) {
        listCompanyCtrl.companies = response.data.data;
      }).finally(function () {
        listCompanyCtrl.loadingService.hideLoading('companyList');
      });
    }
  }]);
  return ListCompanyController;
}();

exports.default = ListCompanyController;


// WEBPACK FOOTER //
// ./client/app/components/admin/entity/list/listCompany/listCompany.controller.js